/*
	jquery.Thermometer

	Copyright (c) 2014 Elon University
	Licensed under the MIT, GPL licenses.

	Does a plugin thing. Ex:
	
	$(document).ready(function(){
		$('.thermometer').Thermometer();
	});
	

*/

(function($) {
	$(document).ready(function(){$(".thermometer-widget").Thermometer();});

		
	$.fn.Thermometer = function(opts) {
		opts = $.extend({}, $.fn.Thermometer.options, opts);
		
		
		this.each(function() {
			var el = $(this);
			el.empty();
			
			var color = el.attr('data-color') || opts.color;
			var maskSrc = el.attr('data-mask') || opts.mask;
			var goalLabel = el.attr('data-goallabel') || opts.goalLabel;
			var currentLabel = el.attr('data-currentlabel') || opts.currentLabel;
			var goalAmount = el.attr('data-goalamount') || opts.goalAmount;
			var currentAmount = el.attr('data-currentamount') || opts.currentAmount;
			var hideGoal = el.attr('data-hidegoal') === 'true';
			
			// if data-goalamount or data-currentamount is a url, load those first, then initialize thermometer, use .then and .done?
			
			if (goalAmount.indexOf('//') > -1 && currentAmount.indexOf('//') > -1) {
				var goalXhr = $.ajax({
					url: goalAmount,
					dataType: 'text',
					cache: false
				});
				
				var currentXhr = $.ajax({
					url: currentAmount,
					dataType: 'text',
					cache: false
				});
				
				$.when(currentXhr, goalXhr).done(function(currentResult, goalResult) {
					$.fn.Thermometer.makeThermometer(el, color, maskSrc, goalLabel, goalResult[0], currentLabel, currentResult[0], hideGoal);
				});
				
				
			} else if (currentAmount.indexOf('//') > -1) {
				var currentXhr = $.ajax({
					url: currentAmount,
					dataType: 'text',
					cache: false
				});
				
				currentXhr.done(function(data){
					$.fn.Thermometer.makeThermometer(el, color, maskSrc, goalLabel, goalAmount, currentLabel, data, hideGoal);
				});
				
			} else {
				$.fn.Thermometer.makeThermometer(el, color, maskSrc, goalLabel, goalAmount, currentLabel, currentAmount, hideGoal);
			}
			
		});
		
		return this;
	};
	
	$.fn.Thermometer.makeThermometer = function(el, color, maskSrc, goalLabel, goalAmount, currentLabel, currentAmount, hideGoal) {
		
		if(maskSrc == 'flame'){
			maskSrc = 'http://www.elon.edu/assets/js/global/components/widgets/thermometer/img/flame.svg';
		}else if(maskSrc == 'up'){
			maskSrc = 'http://www.elon.edu/assets/js/global/components/widgets/thermometer/img/arrow.svg';
		}
		
		// now construct the actual thermometer
		var wrapEl = $('<div class="thermometer-wrap"></div>');
		var maskEl = $('<img class="thermometer-mask" src="' + maskSrc + '" alt="" />');
		var fillEl = $('<div class="thermometer-fill"></div>');
	
		wrapEl.append(maskEl);
		wrapEl.append(fillEl);
		
		var goalDisplayEl = $('<p class="thermometer-goal-display"><span class="thermometer-goal-label">' + goalLabel + '</span> <span class="thermometer-goal-amount">' + goalAmount + '</span></p>');
		var currentAmountDisplayEl = $('<p class="thermometer-current-display"><span class="thermometer-current-label">' + currentLabel + '</span> <span class="thermometer-current-amount">' + currentAmount + '</span></p>');
		
		if (hideGoal === false) {
			el.prepend(goalDisplayEl);
		}
		
		el.append(wrapEl);
		el.append(currentAmountDisplayEl);
		
		var fillPercentage = ($.fn.Thermometer.getNumber(currentAmount) / $.fn.Thermometer.getNumber(goalAmount));
		
		if (fillPercentage > 1.0) {
			fillPercentage = 1.0;
		}
		
		fillEl.animate({ height: (fillPercentage * 99.5) + '%' }, 1000);
		fillEl.css('background-color', color);
	};
	
	
	$.fn.Thermometer.getNumber = function(amountText) {
		return parseFloat(amountText.replace(/[^0-9.]/g, ''));
	}
	$.fn.Thermometer.options = {
		mask: 'http://www.elon.edu/assets/js/global/components/widgets/thermometer/img/flame.svg',
		color: 'rgb(245, 130, 32)',
		goalLabel: 'Goal:',
		currentLabel: 'Current:',
		goalAmount: '0',
		currentAmount: '0'
	};
}(jQuery));